export default "__VITE_ASSET__e7355723__"